// websiteData.js

const websiteData = {
    hero: {
        title: "AI orchestration platform for P&C insurers",
        cta: "Contact us",
        description:
            "Vedra empowers innovative insurers in their quest for scale by collaborating on sourcing, integrating, and innovating on AI",
    },

    mission: {
        title: "Our mission",
        items: [
            "Focus on operational verticals",
            "Orchestrate AI solutions",
            "Make insurance affordable for everyone",
        ],
    },

    valueProps: {
        title: "Why you should partner with Vedra",

        sections: [
            {
                title: "Quest for scale",
                items: [
                    {
                        title: "Incumbent advantage",
                        description:
                            "Certain insurers are pursuing strategies to achieve scale in AI talent, investments, and data.",
                    },
                    {
                        title: "Collaborative disruption",
                        description:
                            "Innovative insurers are disrupting the industry through creative partnerships with AI/tech startups and data pooling.",
                    },
                ],
            },

            {
                title: "Insurtechs have significantly matured",
                items: [
                    {
                        title: "Insurtech maturation",
                        description:
                            "Strong market growth and capital concentration into fewer Insurtechs has led to more mature offerings.",
                    },
                    {
                        title: "Market leaders",
                        description:
                            "Vedra has identified the strongest insurtechs to partner with globally.",
                    },
                ],
            },

            {
                title: "AI orchestration platform",
                items: [
                    {
                        title: "AI powered",
                        description:
                            "Vedra is leveraging AI to build a multi-workflow turnkey platform for the insurance industry.",
                    },
                    {
                        title: "Solution-oriented",
                        description:
                            "The platform started with high friction commercial underwriting and APD claims processing growing to policy servicing centre.",
                    },
                ],
            },
            {
                title: "Operational domains",
                subtitle: "Scale to power world-class AI products",
                description:
                    "Vedra focuses on seven operational domains.",
                extra: {
                    syntheticPooling:
                        "Innovative AI products are built through a unique synthetic pooling approach.",
                },
            },
        ],
    },

    trustBank: {
        title: "Vedra Trust Bank",
        items: [
            {
                title: "Security as a priority",
                description:
                    "Vedra tech stack is built with end-to-end security, zero trust model, and strong resiliency",
            },
            {
                title: "Privacy by design",
                description:
                    "Data is safeguarded with minimization techniques, purpose limitation, and strong governance",
            },
            {
                title: "Safe AI",
                description:
                    "Models are tested and validated to control for unintended outcomes and explainability",
            },
        ],
    },

    footer: {
        copyright: "© Vedra AI inc.",
    },
};

export default websiteData;